import React, { useState } from "react";
import ShowToast from "components/ShowToast";
import { fetchWrapper } from "utils/apiFetch";

// Sends money to a single already-added Cyrus beneficiary via
// billpay_send_money.
//
// Same fix as AddBillpayBankAccountModal: guaranteed inline card styling
// (max-height + internal scroll) on top of the real modal-panel class, and
// inline field styling instead of an unproven `.form-group` class.
const panelStyle = {
  background: "#fff",
  borderRadius: "12px",
  width: "100%",
  maxWidth: "520px",
  maxHeight: "85vh",
  overflowY: "auto",
  boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
};

const fieldStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  marginBottom: "14px",
};

const labelStyle = { fontSize: "13px", color: "#666", fontWeight: 500 };

const inputStyle = {
  padding: "10px 12px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  fontSize: "14px",
  width: "100%",
  boxSizing: "border-box",
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "18px 22px",
  borderBottom: "1px solid #eee",
  gap: "12px",
};

const headerTitleStyle = {
  margin: 0,
  fontSize: "18px",
  fontWeight: 700,
  color: "#1a2b4c",
  flex: "1 1 auto",
  minWidth: 0,
};

const closeBtnStyle = {
  flex: "0 0 auto",
  width: "32px",
  height: "32px",
  minWidth: "32px",
  border: "none",
  background: "#f1f1f1",
  color: "#333",
  borderRadius: "50%",
  fontSize: "18px",
  lineHeight: 1,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const bodyPadStyle = { padding: "18px 22px" };
const footerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  padding: "16px 22px",
  borderTop: "1px solid #eee",
};

const infoRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  fontSize: "14px",
  padding: "6px 0",
  borderBottom: "1px solid #f2f2f2",
};

const MakeBillpaySendMoneyModal = ({ show, onClose, userData, onSuccess }) => {
  const [amount, setAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [transectionMode, setTransectionMode] = useState("IMPS/NEFT/RTGS");
  const [submitting, setSubmitting] = useState(false);

  if (!show || !userData) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount || Number(amount) <= 0) {
      ShowToast("Enter a valid amount", "warning");
      return;
    }

    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("transection_mode", transectionMode);
      formData.append("amount", amount);
      formData.append("holder_name", userData.name);
      formData.append("mobile", userData.mobile || "");
      formData.append("comments", remark || "Bill Pay Settlement");
      formData.append("beneficiaryid", userData.cyrusid);
      formData.append("remark", "Agent Commission");

      const res = await fetchWrapper("https://pro.mokshiq.in/billpay_send_money", {
        method: "POST",
        body: formData,
      });

      if (res?.status) {
        ShowToast(res.message || "Payout submitted successfully", "success");
        onSuccess && onSuccess(res.reference_num);
      } else {
        ShowToast(res?.message || "Payout failed", "danger");
        if (res?.reference_num) {
          onSuccess && onSuccess(res.reference_num);
        }
      }
    } catch (err) {
      ShowToast("Something went wrong while sending money", "danger");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-backdrop-custom" role="dialog" aria-modal="true">
      <div className="modal-panel" style={panelStyle}>
        <div className="modal-header" style={headerStyle}>
          <h5 style={headerTitleStyle}>Settle to {userData.name}</h5>
          <button type="button" style={closeBtnStyle} onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body" style={bodyPadStyle}>
            <div style={infoRowStyle}>
              <span>Account No</span>
              <b>{userData.account}</b>
            </div>
            <div style={infoRowStyle}>
              <span>IFSC</span>
              <b>{userData.IFSC_Code}</b>
            </div>
            <div style={{ ...infoRowStyle, marginBottom: "14px" }}>
              <span>Beneficiary ID</span>
              <b>{userData.cyrusid}</b>
            </div>

            <div style={fieldStyle}>
              <label style={labelStyle}>Transfer Mode</label>
              <select style={inputStyle} value={transectionMode} onChange={(e) => setTransectionMode(e.target.value)}>
                <option value="IMPS/NEFT/RTGS">IMPS / NEFT / RTGS</option>
                <option value="IMPS">IMPS</option>
                <option value="NEFT">NEFT</option>
                <option value="RTGS">RTGS</option>
              </select>
            </div>

            <div style={fieldStyle}>
              <label style={labelStyle}>Amount *</label>
              <input
                style={inputStyle}
                type="number"
                min="1"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
              />
            </div>

            <div style={{ ...fieldStyle, marginBottom: 0 }}>
              <label style={labelStyle}>Remark</label>
              <input style={inputStyle} value={remark} onChange={(e) => setRemark(e.target.value)} placeholder="Optional remark" />
            </div>
          </div>

          <div className="modal-footer" style={footerStyle}>
            <button type="button" className="btn outline" onClick={onClose} disabled={submitting}>
              Close
            </button>
            <button type="submit" className="btn primary" disabled={submitting}>
              {submitting ? "Processing..." : "Settle Now"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MakeBillpaySendMoneyModal;